/* eslint-disable class-methods-use-this */ import { UIMSceneEnum } from '../../../../shared/enums/UIMSceneEnums.ts';
import { SocketLobbySend } from '../../../shared/scripts/socket/SocketLobbySend.ts';
import { UIManagerEvents } from '../../../shared/scripts/ui_html/UIManagerEvents.ts';
import { UIUrlParameterNames } from '../../../shared/scripts/ui_html/UIUrlController.ts';
import { EntryMobileUrlParameterController } from '../EntryMobileUrlParameterController.ts';
import { getHomepageUrlWithParameter, navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
import { UIPopupManager } from '../../../shared/scripts/ui_popup/UIPopupManager.ts';
import { MobileWebviewCommunicationActions } from '@colonist/mobile';
import { UIMMobileWebviewCommunication } from '../ui_mobile_communication/UIMMobileWebviewCommunication.ts';
import { UIDeviceController } from '../../../shared/scripts/ui_html/UIDeviceController.ts';
import { UIMSubscriptionOverlayController } from './store/subscription_overlay/UIMSubscriptionOverlayController.ts';
export class UIMManagerEvents extends UIManagerEvents {
    async createClickedJoinRoomCallback(gameId) {
        await SocketLobbySend.clickedJoinRoom(gameId);
    }
    isSceneLobby() {
        return this.uiManager.sceneController.scene != UIMSceneEnum.Lobby;
    }
    isSceneGame() {
        return this.uiManager.sceneController.scene == UIMSceneEnum.Game;
    }
    leaveRoomAndJoinRoom(roomId) {
        void SocketLobbySend.clickedJoinRoom(roomId);
    }
    performRoomLeavingAction(action) {
        if (this.uiManager.createRoomController.isUserOnCreateRoomFlow()) {
            this.uiManager.createRoomController.onExitRoom(action);
            return;
        }
        action();
    }
    handleUrlRedirectViaParameters(parameter, parameterValue) {
        UIPopupManager.closeAllPopups();
        if (parameter == UIUrlParameterNames.EnterMatchmaking) {
            void EntryMobileUrlParameterController.loadMatchmakingQueue(parameterValue);
            return;
        }
        if (parameter == UIUrlParameterNames.Spectate) {
            navigateToPage(getHomepageUrlWithParameter(parameter, parameterValue));
            return;
        }
    }
    premiumMembershipCheckAction() {
        if (this.showSubscriptionOverlayIfVariant()) return;
        navigateToPage('/store#membership', true, true);
    }
    cancelMatchmakingSearch() {
        this.uiManager.mainpageController.bodyController.homepageController.matchmakingController.stopSearching();
    }
    createSubscriptionOverlayController() {
        return new UIMSubscriptionOverlayController();
    }
    shareImage(title, text, link, imageFile, imageSrc) {
        if (UIDeviceController.isUserOnMobileOrTabletWebBrowser()) {
            void navigator.share({
                title: title,
                text: text,
                url: link,
                files: [
                    imageFile
                ]
            });
            return;
        }
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShareImage, {
            title: title,
            imageSrc: imageSrc
        });
    }
    constructor(uiManager){
        super();
        this.uiManager = uiManager;
    }
}
